import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { itemTypeEntry } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const itemTypeEntrySlice = createSlice({
    name: itemTypeEntry,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetailParams: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetailParams } = itemTypeEntrySlice.actions;
export default itemTypeEntrySlice.reducer;
